/**
 * Legacy URL → new URL redirect map for the WordPress → Lovable migration.
 *
 * Keys MUST be lowercase, start with "/", and have NO trailing slash
 * (normalization in matchRedirect handles trailing slashes, case, and query strings).
 *
 * Values are the destination path on the new site.
 *
 * For true HTTP 301 status codes, mirror this map into the Cloudflare Bulk
 * Redirects CSV (see /mnt/documents/acciongroup-301-redirects.csv once generated).
 */
export const REDIRECTS: Record<string, string> = {
  // ===== Fill in from old WordPress URLs =====
  // Examples (delete and replace with the real list):
  // "/about-us": "/about",
  // "/contact-us": "/contact",
  // "/our-team": "/about",
  // "/services/rfp-management": "/products/powerpro",
  // "/privacy-policy": "/terms-of-use",
};

/**
 * Path prefixes that should always redirect to home, regardless of the rest
 * of the URL. Used for legacy WordPress junk paths that have no equivalent.
 */
export const HOME_FALLBACK_PREFIXES: string[] = [
  "/wp-content",
  "/wp-admin",
  "/wp-includes",
  "/wp-json",
  "/feed",
  "/category",
  "/tag",
  "/author",
  "/?p=",
  "/?page_id=",
];

/**
 * Normalize a pathname for lookup: lowercase, strip trailing slash,
 * drop query string and hash.
 */
export function normalizePath(pathname: string): string {
  let p = pathname.split("?")[0].split("#")[0].toLowerCase();
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p;
}

/**
 * Look up a redirect destination for the given pathname.
 * Returns the new path, or null if there's no match.
 */
export function matchRedirect(pathname: string): string | null {
  const normalized = normalizePath(pathname);
  if (REDIRECTS[normalized]) return REDIRECTS[normalized];
  for (const prefix of HOME_FALLBACK_PREFIXES) {
    if (normalized === prefix || normalized.startsWith(prefix + "/") || normalized.startsWith(prefix)) {
      return "/";
    }
  }
  return null;
}
